import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../config';

const COLLECTION_NAME = 'chatMessages';

const SESSION_KEY = 'xsite_chat_session_id';

export function getSessionId(): string {
  let sessionId = localStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    localStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

export interface ChatMessageDoc {
  sessionId: string;
  appSlug: string;
  language: string;
  stationId: string;
  stationName: string;
  userMessage: string;
  agentReply: string;
  timestamp: ReturnType<typeof serverTimestamp>;
}

export async function saveChatMessage(params: {
  appSlug: string;
  language: string;
  stationId: string;
  stationName: string;
  userMessage: string;
  agentReply: string;
}): Promise<void> {
  if (!db) return;

  const doc: ChatMessageDoc = {
    sessionId: getSessionId(),
    appSlug: params.appSlug,
    language: params.language,
    stationId: params.stationId,
    stationName: params.stationName,
    userMessage: params.userMessage,
    agentReply: params.agentReply,
    timestamp: serverTimestamp(),
  };

  await addDoc(collection(db, COLLECTION_NAME), doc);
}
